import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { format } from 'date-fns';

const BarMultiLineChart = ({ graphData = [], _activeTab }) => {
    const [borderRadius, setBorderRadius] = useState(10);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 1000) {
                setBorderRadius(2);
            } else if (screenWidth < 1500) {
                setBorderRadius(5);
            } else {
                setBorderRadius(7);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Fallback to empty arrays if graphData is undefined or empty
    const dates = graphData?.map(item =>
        item.Date ? format(new Date(item.Date), 'dd-MMM') : 'N/A'
    ) || [];

    const data1 = graphData?.map(item => item.Total_on_hand_Pallets || 0) || [];
    const data2 = graphData?.map(item => item.Threshold || 0) || [];
    const data3 = graphData?.map(item => item.Utilized_pc || 0) || [];
 

    // Chart options
    const options = {
        chart: {
            height: 350,
            type: 'bar',
            stacked: false,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '20%',
                borderRadius: borderRadius,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
            },
        },
        grid: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        // stroke: {
        //     width: 1,
        //     curve: 'straight'
        // },
        
        // ✅ Merge all stroke config here (single block)
        stroke: {
            // global curve for lines
            curve: 'straight',
            // per-series width: [column, line(Utilization), line(Threshold)]
            width: [0, 2, 2],
            // per-series dash: Threshold dashed
            dashArray: [0, 0, 12],
        },

        series: [
            {
                name: "Breach Volume",
                type: 'column',
                data: data1,
                yAxisIndex: 0,
            },
            {
                name: 'Utilization',
                type: 'line',
                data: data3,
                yAxisIndex: 1,
            },
            {
                name: "Threshold",
                type: "line",
                data: data2,
            },
        ],
        colors: [
            '#EC6FBD', 
            '#A4D65D',
            '#000000'
        ],
        xaxis: {
            categories: dates,
        },
        // stroke: {
        //     width: [0, 2, 2],
        //     curve: 'straight',
        //     dashArray: [0, 0, 12],
        // },
        
        yaxis: [
            {
                labels: {
                    formatter: function (value) {
                        return value/1000;
                    }
                },
                title: {
                    text: 'Pallets Breach ("000s)',
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        color: "#333"
                    },
                },
                
            },
            {
                opposite: true,
                labels: {
                    formatter: function (value) {
                        return `${value}%`;
                    }
                },
                title: {
                    text: "Utilization %",
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        color: "#333"
                    },
                },
                min: 0,
            },
        ],
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val) {
                    if (typeof val !== 'undefined') {
                        return val.toFixed(2);
                    }
                    return val;
                }
            },
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            markers: {
                width: 12,  // Set the size of the marker
                height: 12, // Set the size of the marker
                shape: "circle", // Change the shape to circle (round)
            },
        }
    };

    return (
        <div className="grouped-bar-line-chart">
            <ReactApexChart options={options} series={options.series} type="bar" height={350} />
        </div>
    );
};

export default BarMultiLineChart;
